<template>
  <div>
    <v-row dense>
      <v-col>
        <Schedule />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          class="contact-tries-card"
          :loading="contact_attempt_loading"
          outlined
        >
          <v-card-title>
            {{ $capitalize($tc("model.schedulings_contact_attempts")) }}
            <v-spacer></v-spacer>
            <v-btn @click="getContactAttempts()" icon>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>
            <span class="mr-1">
              <v-icon small>mdi-phone</v-icon>
              {{ contact_attempts.filter(ca => ca.success == true).length }}
            </span>
            <span class="mr-2">
              <v-icon color="red lighten-2" small>mdi-phone-off</v-icon>
              {{ contact_attempts.filter(ca => ca.success == false).length }}
            </span>
            <span class="mr-1">
              <v-icon small>mdi-cellphone-message</v-icon>0
            </span>
            <span class="mr-1">
              <v-icon small>mdi-email-outline</v-icon>0
            </span>
            <v-btn text small @click="showAll = !showAll">
              <v-icon small class="mr-1">mdi-cellphone</v-icon>
              {{
                showAll
                  ? $capitalize($tc("model.schedulings_hide_successful"))
                  : $capitalize($tc("model.schedulings_display_all"))
              }}
            </v-btn>
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-list two-line class="contact-attempt-container">
            <v-list-item
              v-for="attempt in failed_contact_attempts"
              :key="attempt.id"
            >
              <v-list-item-icon>
                <v-icon v-if="attempt.success" class="pt-3">mdi-phone</v-icon>
                <v-icon v-else color="red lighten-2" class="pt-3"
                  >mdi-phone-off</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  attempt.participant_name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  attempt.justification ||
                    $capitalize($tc("model.schedulings_no_justification"))
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-menu offset-y transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <ScopeProvider scope="leads.contact_attempts.delete">
                    <v-list>
                      <v-list-item
                        value="true"
                        @click="confirmDeleteContactAttempt(attempt.id)"
                      >
                        <v-icon color="red" left size="20">mdi-delete</v-icon>
                        <v-list-item-title class="red--text">{{
                          $capitalize($tc("model.schedulings_remove_button"))
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </ScopeProvider>
                </v-menu>
                <v-list-item-action-text>{{
                  getContactAttemptDuration(attempt)
                }}</v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="contact_attempt_dialog" max-width="600">
      <v-card>
        <v-form @submit.prevent="addContactAttempt">
          <v-card-title>{{
            $capitalize($tc("model.schedulings_contact_attempts"))
          }}</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="contact_attempt_form.participant_id"
              :items="participants"
              hide-no-data
              hide-selected
              item-text="contact.name"
              item-value="id"
              :label="
                $capitalize($tc('model.schedulings_contacted_participant'))
              "
              :placeholder="
                $capitalize($tc('model.schedulings_search_participant'))
              "
              prepend-icon="mdi-database-search"
            ></v-autocomplete>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="contact_attempt_form.date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="contact_attempt_form.date"
                  :label="$capitalize($tc('model.schedulings_date_label'))"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="contact_attempt_form.date"
                no-title
                scrollable
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">{{
                  $capitalize($tc("model.schedulings_cancel_button"))
                }}</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(contact_attempt_form.date)"
                  >{{ $capitalize($tc("model.schedulings_ok_label")) }}</v-btn
                >
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="contact_attempt_form.time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="contact_attempt_form.time"
                  :label="$capitalize($tc('model.schedulings_time_label'))"
                  prepend-icon="mdi-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu2"
                format="24hr"
                v-model="contact_attempt_form.time"
                full-width
                @click:minute="$refs.menu2.save(contact_attempt_form.time)"
              ></v-time-picker>
            </v-menu>
            <v-radio-group v-model="contact_attempt_form.success">
              <template v-slot:label>{{
                $capitalize($tc("model.schedulings_about_attempted"))
              }}</template>
              <v-radio :value="true">
                <template v-slot:label>{{
                  $capitalize($tc("model.schedulings_success_label"))
                }}</template>
              </v-radio>
              <v-radio :value="false">
                <template v-slot:label>{{
                  $capitalize($tc("model.schedulings_failure_label"))
                }}</template>
              </v-radio>
            </v-radio-group>
            <v-text-field
              :label="$capitalize($tc('model.schedulings_justification_label'))"
              v-model="contact_attempt_form.justification"
              counter="512"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="contact_attempt_dialog = false">{{
              $capitalize($tc("model.schedulings_cancel_button"))
            }}</v-btn>
            <v-btn type="submit" color="primary">{{
              $capitalize($tc("model.schedulings_save_button"))
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    
    <confirm-action-dialog
      :confirm_action="contact_attempt_deletion"
      @change="contact_attempt_deletion = $event"
      @action="removeContactAttempt()"
      :message="$capitalize($tc('model.schedulings_message_remove_attempt'))"
    ></confirm-action-dialog>
  </div>
</template>

<script>
import ConfirmActionDialog from "../../ConfirmActionDialog";
import { index as indexSchedulings } from "@/services/scheduling";
import {
  indexContactAttempt,
  destroyContactAttempt
} from "@/services/contact_attempts";
import ScopeProvider from "@/components/ScopeProvider";
import Schedule from "@/components/Lead/Scheduling/Schedule";

export default {
  components: { Schedule, ConfirmActionDialog, ScopeProvider },
  data: () => ({
    contact_attempts: [],
    contact_attempt_deletion: false,
    contact_attempt_delete_id: null,
    contact_attempt_loading: false,
    contact_attempt_dialog: false,
    contact_attempt_form: {},
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    showAll: false
  }),
  methods: {
    getContactAttemptDuration(attempt) {
      const attempt_moment = this.$moment(`${attempt.date} ${attempt.time}`);
      const now = this.$moment();

      return this.$moment.duration(attempt_moment.diff(now)).humanize(true);
    },
    async getSchedulings() {
      this.scheduling_loading = true;

      try {
        const schedulings = await indexSchedulings(this.$route.params["lead_number"]);
        this.schedulings = schedulings.map(scheduling => {
          const date = this.$moment(scheduling.date + " " + scheduling.time);

          return {
            name: scheduling.participant?.contact?.name.substring(0, 10).trim()  + '...',
            start: date.toDate(),
            color: scheduling.type.color,
            timed: true,
            edit: () => this.editScheduling(scheduling)
          };
        });
      } finally {
        this.scheduling_loading = false;
      }
    },
    async getContactAttempts() {
      this.contact_attempt_loading = true;
      try {
        this.contact_attempts = [];

        const response = await indexContactAttempt({
          lead_identifier_code: this.$route.params["lead_number"]
        });

        this.contact_attempts = response;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar tentativas de contactos",
          color: "red"
        });
      } finally {
        this.contact_attempt_loading = false;
      }
    },
    confirmDeleteContactAttempt(id) {
      this.contact_attempt_delete_id = id;
      this.contact_attempt_deletion = true;
    },
    async addContactAttempt() {
      try {
        const response = await this.$http.post("/contact_attempts", {
          ...this.contact_attempt_form,
          lead_id: this.lead.id
        });
        this.contact_attempt_form = {};
        this.contact_attempt_dialog = false;
        this.$store.commit("sendMessage", {
          text: "Tentativa de contacto adicionada"
        });
        this.getContactAttempts();
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao adicionar tentativa de contacto",
          color: "red"
        });
      }
    },
    async removeContactAttempt() {
      this.contact_attempt_loading = true;
      try {
        await destroyContactAttempt(this.contact_attempt_delete_id);
        this.contact_attempts = this.contact_attempts.filter(
          attempt => attempt.id !== this.contact_attempt_delete_id
        );

        this.$store.commit("sendMessage", {
          text: "Tentativa de contacto removida"
        });

        this.contact_attempt_deletion = false;
        this.contact_attempt_delete_id = null;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: error.response.data.message,
          color: "red"
        });
      } finally {
        this.contact_attempt_loading = false;
      }
    }
  },
  created() {
    this.getContactAttempts();
  },
  computed: {
    lead: function() {
      return this.$store.getters.getLead;
    },
    participants: function() {
      return this.lead ? this.lead.participants : [];
    },
    failed_contact_attempts: function() {
      return this.contact_attempts.filter(attempt => {
        if (this.showAll) {
          return true;
        } else {
          return attempt.success === false;
        }
      });
    }
  }
};
</script>
